import React from "react";
import Box from "@material-ui/core/Box";
import useStyles from "./styles";
import { racehorse360 } from "@tsg/1st-grpc-web-rh360";
import clsx from "clsx";

interface Props {
  healthWatchStatus: racehorse360.HealthWatchStatus;
}

const AbcCircle = (props: Props) => {
  const classes = useStyles();
  const { healthWatchStatus } = props;

  if (!healthWatchStatus) {
    return <></>;
  }

  return <Box className={clsx(classes.root, classes[healthWatchStatus])} />;
};

export default AbcCircle;
